module.exports = __webpack_public_path__ + "static/media/Longieren02.b94ff8e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Longieren02.jpg
// module id = 347
// module chunks = 0